// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var clamp = "MatchCardSkeleton-module--clamp--4be8b";
export var cluster = "MatchCardSkeleton-module--cluster--3dca8";
export var countdownClamp = "MatchCardSkeleton-module--countdownClamp--d7f00";
export var emphasis = "MatchCardSkeleton-module--emphasis--3e8c7";
export var green = "#57d33b";
export var greenLink = "MatchCardSkeleton-module--green-link--26b4d";
export var grey = "var(--tone-mid)";
export var header = "MatchCardSkeleton-module--header--a05fe";
export var icon = "MatchCardSkeleton-module--icon--98ce9";
export var matchCardSkeleton = "MatchCardSkeleton-module--matchCardSkeleton--5ce6c";
export var name = "MatchCardSkeleton-module--name--9818b";
export var nameAndOdds = "MatchCardSkeleton-module--nameAndOdds--698c2";
export var notchGap = "32px";
export var odds = "MatchCardSkeleton-module--odds--1962c";
export var orange = "#f8662b";
export var outcome = "MatchCardSkeleton-module--outcome--e5f5e";
export var outcomeIcon = "MatchCardSkeleton-module--outcomeIcon--c9b7e";
export var outcomes = "MatchCardSkeleton-module--outcomes--9b577";
export var red = "#ff2741";
export var subtitle = "MatchCardSkeleton-module--subtitle--5d4f9";
export var title = "MatchCardSkeleton-module--title--4059a";
export var titleWrapper = "MatchCardSkeleton-module--titleWrapper--55d56";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";